// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "details {\n  visibility: hidden; }\n\n.vega-embed {\n  position: relative;\n  display: inline-block;\n  padding-right: 0px; }\n", ""]);
// Exports
module.exports = exports;
